document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(min-width: 990px) and (hover: hover)');
  if (!mq.matches) return;

  const menus = Array.from(document.querySelectorAll('header-menu > details'));
  if (!menus.length) return;

  const positionMenu = (details) => {
    const menu =
      details.querySelector('.mega-menu__content') ||
      details.querySelector('.header__submenu');
    const summary = details.querySelector('summary');
    if (!menu || !summary) return;

    const viewportWidth = window.innerWidth;
    const padding = 16;
    const summaryRect = summary.getBoundingClientRect();

    const menuRect = menu.getBoundingClientRect();
    const menuWidth = menu.offsetWidth || menuRect.width || Math.min(viewportWidth * 0.6, 960);

    const desiredLeft = summaryRect.left + summaryRect.width / 2 - menuWidth / 2;
    const clampedLeft = Math.max(padding, Math.min(desiredLeft, viewportWidth - menuWidth - padding));

    const offsetParent = menu.offsetParent;
    const parentLeft = offsetParent ? offsetParent.getBoundingClientRect().left : 0;

    menu.style.left = `${clampedLeft - parentLeft}px`;
    menu.style.right = 'auto';
  };

  const closeAll = (except) => {
    menus.forEach((details) => {
      if (details === except) return;
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
  };

  menus.forEach((details) => {
    let closeTimer;

    const openMenu = () => {
      if (!mq.matches) return;
      window.clearTimeout(closeTimer);
      closeAll(details);
      details.setAttribute('open', '');
      details.classList.add('menu-opening');
      positionMenu(details);
    };

    const closeMenu = () => {
      if (!mq.matches) return;
      closeTimer = window.setTimeout(() => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      }, 140);
    };

    details.addEventListener('mouseenter', openMenu);
    details.addEventListener('mouseleave', closeMenu);
    details.addEventListener('focusin', openMenu);
    details.addEventListener('focusout', closeMenu);

    const summary = details.querySelector('summary');
    if (summary) {
      summary.addEventListener('click', (event) => {
        if (mq.matches) {
          event.preventDefault();
          if (summary.dataset.href) window.location.href = summary.dataset.href;
        }
      });
    }
  });

  window.addEventListener('resize', () => {
    menus.forEach((details) => {
      if (details.hasAttribute('open')) {
        positionMenu(details);
      }
    });
  });
});
